import { ConflictAlertSeverityBadge } from '../badges/ConflictAlertSeverityBadge';
import { ConflictAlertStatusBadge } from '../badges/ConflictAlertStatusBadge';
import { ConflictAlertTypeBadge } from '../badges/ConflictAlertTypeBadge';

import type { ConflictAlertHistoryRowVM } from '../../view-models';
import type React from 'react';

export interface ConflictAlertHistoryRowProps {
  row: ConflictAlertHistoryRowVM;
  onOpenDrawer: (r: ConflictAlertHistoryRowVM) => void;
  onReopen: (r: ConflictAlertHistoryRowVM) => void;
  /**
   * Re-abrir honesto desabilitado (sem endpoint backend — Item 322). Quando true,
   * o botão "Re-abrir" fica disabled + title explicativo. Default false (T7-1).
   */
  reopenDisabled?: boolean;
}

const REOPEN_DISABLED_TITLE = 'Reabertura em implementação — ainda não disponível';

// ─── HistoryRow — linha do tab Histórico §12.8 (verbatim de cards-3.jsx:588-615)
export function ConflictAlertHistoryRow({
  row,
  onOpenDrawer,
  onReopen,
  reopenDisabled = false,
}: ConflictAlertHistoryRowProps): React.JSX.Element {
  return (
    <div className="ca-hist-row">
      <div className="ca-hist-row__top">
        <ConflictAlertSeverityBadge severity={row.severity} />
        <ConflictAlertTypeBadge alertType={row.alertType} />
        <span className="ca-hist-row__time mono">{row.detectedAt}</span>
        <span style={{ flex: 1 }} />
        <span className="ca-hist-row__mitig mono">mitig. {row.mitigationTime}</span>
      </div>
      <div className="ca-hist-row__bottom">
        <div className="ca-hist-row__title">{row.title}</div>
        <div className="ca-hist-row__parties">{row.partiesShort}</div>
        <ConflictAlertStatusBadge status={row.resolution.status} />
        <span className="ca-hist-row__resolved mono">
          {row.resolution.label} · {row.resolution.at}
          {row.resolution.byUser != null && row.resolution.byUser !== ''
            ? ' · ' + row.resolution.byUser
            : null}
          {row.resolution.ttlDays != null && row.resolution.ttlDays !== 0
            ? ` · TTL ${row.resolution.ttlDays}d`
            : null}
        </span>
        <span style={{ flex: 1 }} />
        <button className="btn-ghost-mini" onClick={() => onOpenDrawer(row)}>
          Ver detalhes
        </button>
        {(row.resolution.status === 'resolved' ||
          row.resolution.status === 'mitigated' ||
          row.resolution.status === 'false_positive') && (
          <button
            className="btn-ghost-mini"
            onClick={() => onReopen(row)}
            disabled={reopenDisabled}
            title={reopenDisabled ? REOPEN_DISABLED_TITLE : undefined}
          >
            Reabrir
          </button>
        )}
      </div>
    </div>
  );
}
